const style = {
  searchButton: {
    width: '100%',
    maxWidth: '70%'
  }
}

export default style
